import React from 'react';

import { CreditCardOutline, Yen } from '@travel/icons/service';
import PlanPaymentRestrictionCore from '@travel/traveler-core/components/PlanPaymentRestriction';

import { PLAN_PAYMENT_MANAGEMENT_NAME } from 'constants/provider';
import type { PlanPaymentRestrictionFeature } from 'ProviderRatePlan-Types';

import styles from './planPaymentRestriction.module.scss';

type Props = {
  className?: string;
  titleClassName?: string;
  isShowIcon?: boolean;
} & PlanPaymentRestrictionFeature;

function PlanPaymentRestriction(props: Props) {
  const { isShowIcon = true, ...restProps } = props;

  if (!props.managementName) {
    return null;
  }

  const Icon =
    props.managementName === PLAN_PAYMENT_MANAGEMENT_NAME.CASH_ONLY ? Yen : CreditCardOutline;

  return (
    <PlanPaymentRestrictionCore
      {...restProps}
      Icon={
        isShowIcon ? (
          <Icon
            data-testid={`planPaymentRestriction-${props.managementName}-icon`}
            className={styles.icon}
            size={16}
          />
        ) : null
      }
    />
  );
}

export default PlanPaymentRestriction;
